import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim, grayscale, white} from '/theme/color/on.color';
import {alto, codGray, mineShaft} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  widgetBase: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    borderRadius: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    backgroundColor: white,
    borderColor: alto,
    marginVertical: indent,
  },
  widgetPadding: {
    paddingVertical: indent,
    paddingRight: indent * 0.2,
    paddingLeft: indent,
  },
  noOrderPadding: {
    padding: indent,
  },
  widgetContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  titleText: {
    fontSize: 16,
    ...getFontFamily('bold'),
    color: codGray,
    marginTop: indent * 0.1,
  },
  widgetStatusContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  arrowIcon: {
    color: grayscale,
    fontSize: 25,
  },
  orderStatusIcon: {
    marginRight: indent * 0.35,
    color: grayscale,
    fontSize: 23,
  },
  divider: {
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: alto,
    marginBottom: indent * 0.9,
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  orderStatusText: {
    fontSize: 16,
    ...getFontFamily('bold'),
    color: mineShaft,
    marginRight: indent * 0.25,
  },
  orderDateContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: indent,
    marginTop: indent * 0.3,
  },
  orderMultipleDateContainer: {
    marginTop: indent * 0.5,
  },
  orderDateText: {
    fontSize: 14,
    fontWeight: '400',
    color: codGray,
  },
  orderTrackingContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  orderTrackingContainerMargin: {
    marginTop: indent,
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  orderTrackingText: {
    fontSize: 14,
    color: codGray,
    ...getFontFamily('bold'),
  },
  orderTrackingIdText: {
    fontSize: 14,
    fontWeight: '600',
    color: denim,
    marginRight: indent * 0.5,
  },
  multiplePackageContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  packageContainer: {
    marginBottom: indent * 0.25,
  },
  // @ts-expect-error TS(2322): Type '{ color: string; fontFamily: string; fontWei... Remove this comment to see the full error message
  packageText: {
    fontSize: 14,
    ...getFontFamily('bold'),
    color: codGray,
  },
  multiOrderContainer: {
    marginRight: indent * 3,
  },
  multiPackageContainerMargin: {
    marginBottom: 20,
  },
  noOrderDescription: {
    marginTop: indent * 0.5,
  },
  noOrderDescriptionContainer: {
    width: '100%',
  },
});
